// let hSession = "";
// let process = false;
// const LibList_MACOS = "viettel-ca_v5.dylib;viettel-ca_v4.dylib";
// var LibList_WIN = "viettel-ca_v5.dll;viettel-ca_v4.dll;viettel-ca_v2.dll";
//
// var domain = "http://127.0.0.1:14007/";
function showErrMsg_CMS(comp, code) {
  switch (code) {
    case "100100":
      comp.showErrMsgTransle("messages.error_not_certificate");
      return false;
    case "100101":
      comp.showErrMsgTransle("messages.error_interactive_plugin");
      return false;
    case "100102":
    case "100202":
      comp.showErrMsgTransle("messages.error_certificate_wrong_or_permission");
      return false;
    case "100103":
    case "100205":
    case "100303":
      comp.showErrMsgTransle("messages.error_session_wrong");
      return false;
    case "100104":
      comp.showErrMsgTransle("messages.error_certificate_expired");
      return false;
    case "100200":
      comp.showErrMsgTransle("messages.error_data_wrong");
      return false;
    case "100201":
      comp.showErrMsgTransle("messages.error_not_find_certificate");
      return false;
    default:
      comp.blockUI.stop();
      comp.showErrMsgTransle("messages.not_initPlugin");
      // comp.showErrMsg('Lỗi: ' + code);
      return false;
  }
}

let hSession = "";
let process = false;
let domain = "http://127.0.0.1:19650/";
const fallbackDomain = "http://127.0.0.1:19750/";
let triedFallback = false;

function initPluginCertificate(comp, contracts) {
  let xmlhttp;
  let response = "";

  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest();
  } else {
    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  }

  xmlhttp.onreadystatechange = function () {
    console.log("vao day");
    if (xmlhttp.readyState === 4) {
      comp.blockUI.stop();

      if (xmlhttp.status === 200) {
        let res = xmlhttp.responseText;

        if (!res) {
          handleFinalError(comp, contracts);
          return;
        }

        try {
          response = JSON.parse(res);
        } catch (e) {
          handleFinalError(comp, contracts);
          return;
        }

        if (response && response.error && response.error.errorCode === 436) {
          comp.errorInitPlugin = true;
          comp.showErrMsgTransle(
            contracts && contracts.length > 0
              ? "messages.sign_fail_user_cancellation"
              : "messages.not_initPlugin",
            true
          );
          return;
        }

        if (response && response.error && response.error.errorCode === 437) {
          comp.errorInitPlugin = true;
          comp.showErrMsgTransle(
            contracts && contracts.length > 0
              ? "messages.sign_batch_parallel"
              : "messages.not_initPlugin",
            true
          );
          return;
        }

        if (response && response.sessionId) {
          hSession = response.sessionId;
          comp.errorInitPlugin = false;
          comp.errorStatus = null;
          comp.setSessionId(hSession);
          selectedCertificate(comp, contracts);
          return;
        } else {
          handleFinalError(comp, contracts);
        }
      } else {
        console.log("vao else", triedFallback);
        if (!triedFallback) {
          triedFallback = true;
          domain = fallbackDomain;
          console.warn("Retrying with fallback domain:", domain);
          initPluginCertificate(comp, contracts);
        } else {
          handleFinalError(comp, contracts);
        }
      }
    }
  };

  xmlhttp.open("POST", domain + "getSession", true);

  if (contracts && contracts.length > 0) {
    comp.blockUI.start("");
    xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xmlhttp.send(JSON.stringify({ contracts }));
  } else {
    xmlhttp.send();
  }
}

function handleFinalError(comp, contracts) {
  domain = "http://127.0.0.1:19650/";
  comp.errorInitPlugin = true;
  comp.showErrMsgTransle(
    contracts && contracts.length > 0
      ? "messages.not_connect_plugin"
      : "messages.not_initPlugin",
    true
  );
}

function initPluginCertificateApprove(comp, contracts) {
  console.log("chay vao ham initPluginCertificateApprove");
  let xmlhttp;
  let response = "";
  // code for IE7+, Firefox, Chrome, Opera, Safari
  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest();
  } else {
    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  }
  xmlhttp.onreadystatechange = function () {
    console.log("vao day");
    let res;
    if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
      console.log("vao day res 4");

      comp.blockUI.stop();
      res = xmlhttp.responseText;
      if (!res) {
        comp.errorInitPlugin = true;
        if (contracts && contracts.length > 0) {
          comp.showErrMsgTransle(
            "messages.approve_fail_user_cancellation",
            true
          );
        } else {
          comp.showErrMsgTransle("messages.not_initPlugin", true);
        }
        return;
      }

      response = JSON.parse(res);
      console.log("res init session ", response);
      process = false;

      if (response && response.error && response.error.errorCode === 436) {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransle(
          contracts && contracts.length > 0
            ? "messages.approve_fail_user_cancellation"
            : "messages.not_initPlugin",
          true
        );
        return;
      }

      if (response && response.error && response.error.errorCode === 437) {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransle(
          contracts && contracts.length > 0
            ? "messages.approve_batch_parallel"
            : "messages.not_initPlugin",
          true
        );
        return;
      }

      if (response) {
        hSession = response.sessionId;
        comp.errorInitPlugin = false;
        comp.errorStatus = null;
        // comp.blockUI.stop();
        comp.setSessionId(hSession);
        selectedCertificate(comp, contracts);
        return;
      }

      if (!response) {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransle(
          contracts && contracts.length > 0
            ? "messages.approve_fail_user_cancellation"
            : "messages.not_initPlugin",
          true
        );
        return;
      }
    }

    if (xmlhttp.readyState === 4 && xmlhttp.status === 0) {
      comp.blockUI.stop();
      console.log("vao else", triedFallback);
      if (!triedFallback) {
        triedFallback = true;
        domain = fallbackDomain;
        console.warn("Retrying with fallback domain:", domain);
        initPluginCertificateApprove(comp, contracts);
      } else {
        handleFinalError(comp, contracts);
      }
    }
  };
  xmlhttp.open("POST", domain + "getSession", true);
  xmlhttp.send();
}

function initPluginCertificateNormal(comp, contracts) {
  console.log("chay vao ham initPluginCertificateNormal");
  let xmlhttp;
  let response = "";
  // code for IE7+, Firefox, Chrome, Opera, Safari
  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest();
  } else {
    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  }
  xmlhttp.onreadystatechange = function () {
    let res;
    if (xmlhttp.readyState === 4 && xmlhttp.status === 0) {
      if (contracts && contracts.length > 0) {
        comp.showErrMsgTransle("messages.sign_fail_user_cancellation");
      } else {
        comp.showErrMsgTransle("messages.not_initPlugin");
      }
    }
    if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
      res = xmlhttp.responseText;
      console.log("Res", res);
      if (!res) {
        console.log("!res");
        comp.errorInitPlugin = true;
        if (contracts && contracts.length > 0) {
          comp.showErrMsgTransle("messages.sign_fail_user_cancellation");
        } else {
          comp.showErrMsgTransle("messages.not_initPlugin");
        }
        return;
      }
      response = JSON.parse(res);
      process = false;
      if (response) {
        hSession = response.sessionId;
        comp.errorInitPlugin = false;
        comp.errorStatus = null;
        // comp.blockUI.stop();
        comp.setSessionId(hSession);
        selectedCertificateNormal(comp, contracts);
        return;
      }

      if (!response) {
        comp.errorInitPlugin = true;
        if (contracts && contracts.length > 0) {
          comp.showErrMsgTransle("messages.sign_fail_user_cancellation");
        } else {
          comp.showErrMsgTransle("messages.not_initPlugin");
        }

        return;
      }
    }

    if (xmlhttp.readyState === 4 && xmlhttp.status === 0) {
      console.log("vao else", triedFallback);
      if (!triedFallback) {
        triedFallback = true;
        domain = fallbackDomain;
        console.warn("Retrying with fallback domain:", domain);
        initPluginCertificate(comp, contracts);
      } else {
        handleFinalError(comp, contracts);
      }
    }
  };
  xmlhttp.open("POST", domain + "getSession", true);

  if (contracts && contracts.length > 0) {
    xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xmlhttp.send(JSON.stringify({ contracts }));
  } else {
    xmlhttp.send();
  }
}

/**
 * Substring get CMND/MST from DN
 * @param ReqDN
 */

function selectedCertificate(comp, contracts) {
  if (process === true) {
    return;
  }
  let ReqCert;
  if (window.XMLHttpRequest) {
    // code for IE7+, Firefox, Chrome, Opera, Safari
    ReqCert = new XMLHttpRequest();
  } else {
    // code for IE6, IE5
    ReqCert = new ActiveXObject("Microsoft.XMLHTTP");
  }
  ReqCert.onreadystatechange = function () {
    if (ReqCert.readyState === 4 && ReqCert.status === 200) {
      comp.blockUI.stop();
      const responseAsJSON = JSON.parse(ReqCert.responseText);
      if (!responseAsJSON) {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransle(
          contracts && contracts.length > 0
            ? "messages.not_connect_plugin"
            : "messages.not_initPlugin"
        );
        return;
      }
      const error = responseAsJSON.error;
      if (error) {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransle(
          contracts && contracts.length > 0
            ? "messages.not_connect_plugin"
            : "messages.not_initPlugin"
        );
        // comp.showErrMsgTransle("messages.not_initPlugin");
        return;
      }
      const cert = responseAsJSON.cert;
      const { cn, dn, issuerCn, issuerDn, serialNumber } = cert;
      let { validFrom, validTo, certBase64 } = cert;
      const now = new moment();
      validFrom = moment(validFrom, "DD/MM/YYYY hh:mm:ss");
      validTo = moment(validTo, "DD/MM/YYYY hh:mm:ss");
      if (validTo < now) {
        comp.showErrMsgTransle("messages.certificate_expired");
        return;
      }

      if (certBase64) {
        certBase64 = certBase64.replace("-----BEGIN CERTIFICATE-----", "");
        certBase64 = certBase64.replace("-----END CERTIFICATE-----", "");
        certBase64 = certBase64.trim();
      }
      const data = {
        certBase64,
        serialNumber,
        issuedTo: cn,
        distinguishedName: dn,
        taxCode: subStringTaxCode(dn),
        issuedBy: issuerCn,
        activeDate: validFrom,
        expireDate: validTo,
        activeContinueButton: true,
      };
      comp.setCertRawdata(certBase64);
      comp.setSerialNumber(serialNumber);
      comp.setIssuedTo(cn);
      comp.setDistinguishedName(dn);
      comp.setTaxCode(subStringTaxCode(dn));
      comp.setIssuedBy(issuerCn);
      comp.setActiveDate(validFrom);
      comp.setExpireDate(validTo);
      if (comp.setActiveContinueButton) {
        comp.setActiveContinueButton();
      }
      comp.setCertData(data);
      if (contracts && contracts.length > 0) {
        comp.processSignLotUsingUsbToken();
      }
      if (comp.type && comp.type === "verify-enterprice") {
        comp.isDisableNextButton = false;
        comp.errorStatus = null;
      }
    }
  };
  // if(contracts && contracts.length > 0){
  comp.blockUI.reset();
  comp.blockUI.start("");
  // }
  ReqCert.open("POST", domain + "getCert", true);
  ReqCert.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  ReqCert.send("sessionId=" + hSession);
}

function anonymousSignHashAsyncNew(comp, hashBase64, sessionId, serialNumber) {
  return new Promise((resolve, reject) => {
    // comp.blockUI.reset();
    // comp.blockUI.start();
    if (!sessionId) {
      comp.showErrMsgTransle("messages.initPlugin_faile");
    }
    let signature = "";
    if (!sessionId || !hashBase64 || !serialNumber) {
      comp.showErrMsgTransle("messages.initPlugin_faile");
    }
    var functionName = "signHash";
    var paramNameArray = ["sessionId", "serialNumber", "hashBase64", "hashAlg"];
    var paramValueArray = [sessionId, serialNumber, hashBase64, "SHA256"]; //HashOpt: loai ma hash (0: SHA-1; 1:MD5; 2:SHA256)
    let xmlhttp;
    if (window.XMLHttpRequest) {
      // code for IE7+, Firefox, Chrome, Opera, Safari
      xmlhttp = new XMLHttpRequest();
    } else {
      // code for IE6, IE5
      xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }

    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState === 4 && xmlhttp.status !== 200) {
        comp.showErrMsgTransle("messages.not_initPlugin");
        reject();
      }
      if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
        // response = xmlhttp.responseText;
        // resolve(response);
        // comp.blockUI.stop();
        const responseAsJSON = JSON.parse(xmlhttp.responseText);
        if (!responseAsJSON) {
          comp.showErrMsgTransle("messages.not_initPlugin");
        }
        const error = responseAsJSON.error;
        if (error) {
          comp.showErrMsgTransle(getErrorMessage(error.errorCode));
        }
        var { signatureBase64 } = responseAsJSON;
        if (signatureBase64) {
          signature = signatureBase64;
        }
        resolve(signature);
      }
    };

    var method = "POST";
    var url = domain + functionName;
    var async = true; //Gui yeu cau bat chay dong bo
    xmlhttp.open(method, url, async);

    xmlhttp.setRequestHeader(
      "Content-type",
      "application/x-www-form-urlencoded"
    );
    if (
      !paramNameArray ||
      !Array.isArray(paramNameArray) ||
      paramNameArray.length === 0 ||
      !paramValueArray ||
      !Array.isArray(paramValueArray) ||
      paramValueArray.length === 0 ||
      paramNameArray.length !== paramValueArray.length
    ) {
      try {
        xmlhttp.send();
      } catch (err) {
        reject(err);
      }
    } else {
      let data = "";
      for (let i = 0; i < paramNameArray.length; i++) {
        data += paramNameArray[i] + "=" + paramValueArray[i] + "&";
      }
      if (data.length > 0) {
        data = data.substring(0, data.length - 1); //Loai bo ky tu & cuoi cung
      }
      try {
        xmlhttp.send(data);
      } catch (err) {
        reject(err);
      }
    }
  });
}

function selectedCertificateNormal(comp, contracts) {
  if (process === true) {
    return;
  }
  let ReqCert;
  if (window.XMLHttpRequest) {
    // code for IE7+, Firefox, Chrome, Opera, Safari
    ReqCert = new XMLHttpRequest();
  } else {
    // code for IE6, IE5
    ReqCert = new ActiveXObject("Microsoft.XMLHTTP");
  }
  ReqCert.onreadystatechange = function () {
    if (ReqCert.readyState === 4 && ReqCert.status === 0) {
      comp.showErrMsgTransle("messages.not_initPlugin");
    }
    if (ReqCert.readyState === 4 && ReqCert.status === 200) {
      const responseAsJSON = JSON.parse(ReqCert.responseText);
      if (!responseAsJSON) {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransle("messages.not_initPlugin");
        return;
      }
      const error = responseAsJSON.error;
      if (error) {
        comp.errorInitPlugin = true;
        comp.showErrMsgTransle("messages.not_initPlugin");
        if (comp.showErrorDialog) {
          comp.showErrMsgTransle(getErrorMessage(error.errorCode));
        }
        return;
      }
      const cert = responseAsJSON.cert;
      const { cn, dn, issuerCn, issuerDn, serialNumber } = cert;
      let { validFrom, validTo, certBase64 } = cert;
      const now = new moment();
      validFrom = moment(validFrom, "DD/MM/YYYY hh:mm:ss");
      validTo = moment(validTo, "DD/MM/YYYY hh:mm:ss");
      if (validTo < now) {
        comp.showErrMsgTransle("messages.certificate_expired");
        return;
      }
      if (certBase64) {
        certBase64 = certBase64.replace("-----BEGIN CERTIFICATE-----", "");
        certBase64 = certBase64.replace("-----END CERTIFICATE-----", "");
        certBase64 = certBase64.trim();
      }
      const data = {
        certBase64,
        serialNumber,
        issuedTo: cn,
        distinguishedName: dn,
        taxCode: subStringTaxCode(dn),
        issuedBy: issuerCn,
        activeDate: validFrom,
        expireDate: validTo,
        activeContinueButton: true,
      };
      let dataValid = true;
      for (const [key, value] of Object.entries(data)) {
        if (!value) {
          dataValid = false;
          break;
        }
      }
      if (!dataValid) {
        comp.showErrMsgTransle("messages.certificate_info_not_valid");
        return;
      }
      comp.createHash(certBase64);
      comp.setCertRawdata(certBase64);
      comp.setSerialNumber(serialNumber);
      comp.setIssuedTo(cn);
      comp.setDistinguishedName(dn);
      comp.setTaxCode(subStringTaxCode(dn));
      comp.setIssuedBy(issuerCn);
      comp.setActiveDate(validFrom);
      comp.setExpireDate(validTo);
      comp.setActiveContinueButton();
    }
  };
  ReqCert.open("POST", domain + "getCert", true);
  ReqCert.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  ReqCert.send("sessionId=" + hSession);
}

// strContracts: là trường làm hai nhiệm vụ
// 1: đối với ký 1 lần thì strContracts nhận đầu vào là 1 string: hashBase64
// 2: đối với ký nhiều file thì strContracts nhận đầu vào là 1 mảng với cấu trúc
// chú ý: vì là gọi từ ts --> js lên tham số strContracts bắt buộc phải là 1 string. Sau đó được parse
// example
//[
//     {
//         "path": "22D0551A6ADE3475A37F485E5DCF36734CA241A4F45F35C09ABDB40A695D565A",
//         "hash": "B/tohtbZMB6K5lLVqGrwWT4wnOBJoAGAw+0ZL3S9Yys=",
//         "signPdf": "B4C56DCBFB7B384DDE2EF59EA06AB9B327ED54C44AF6AD573CF0C2879F4DF061",
//         "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA=="
//     }
// ]
// return
// 1: tra ve nhu cu
// 2:
//   [
//   {
//     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA==",
//     "fileName": null,
//     "path": "22D0551A6ADE3475A37F485E5DCF36734CA241A4F45F35C09ABDB40A695D565A",
//     "hash": "B/tohtbZMB6K5lLVqGrwWT4wnOBJoAGAw 0ZL3S9Yys=",
//     "signPdf": "B4C56DCBFB7B384DDE2EF59EA06AB9B327ED54C44AF6AD573CF0C2879F4DF061",
//     "signatureBase64": "Vs/xuF6efxGb6JPJmT9P0/qBGhfu53WlDzw5P1P7MaJXQuLhHxnQlV/TrbEMP6FdnEj4WLzWqhZSmvb+0KAO3J21ChTXL1z2V68zF6xqigeQwIQFpH9vgayi5raBDlC2p46VaflO5Pgri9cDiYEgZ7LzeQobkf60vfTW1h0fzb51uDXsIrjLHZ5gsdt4NvuoT8DsDtcQKGn7hl7cnZua0QMWytQ2cL8oKHFgOAn12O3g3q23H/SUdBDua3ll+OoQB8l08i8V1RjAQNgzuAE8r0toeFZUKIx00C6RaLp8ZxpUjTI3i/HtXiC3J425aV85nQFUaS7rARblihCykDKNRg=="
//   },
//   {
//     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA==",
//     "fileName": null,
//     "path": "9EED391DA696EEBCD1D80713ECA32937E3D4DF0AE637AE290733FEBD365AB87F",
//     "hash": "zps7wM9HdMdZ6XDNd 8nbbpr1PkGMNunweEUqlY9Os0=",
//     "signPdf": "2F31AEF62DB92FB922437E29E987FA44005FB94614C81F416144FDEF9C0FF916",
//     "signatureBase64": "Xf7DNEcd0kVOJWgCWr+thLvQmUJKIbfP4CH5jhnB0Llu5lk3HF6K9Xy+F+vaWeoVfUewifgbfChmsl96/YmWdmkS5ETTjI4yHbzpxdbNxQPO7YE+YBQLH80U6Puu5qnWKNmvLKYQkrfba7oWOtcQFHUxN339DJwuasVuyUWXX3+62yy39n+6fUoDVFftRjg6NzzFMTWUQ5e2CPXcsCmTj1WInlEL5iTB2vkWqdwaPdGuQ3SLT6z9afZhWBnNY+0RVujtTtXFyqVzjUF2oh6bIusfcmpccBhlFtd/z8MnXmbcvgkoHrkh+trME8s+LRR8qJedyAYSgfX5VqW5zlJ8TA=="
//   },
//   {
//     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA==",
//     "fileName": null,
//     "path": "B4A53F10316C3E7801F93DE40E6665A655D7DA4AF11093001EA84BC3AE880844",
//     "hash": "9UGbDMH4H6lq0AQi6SSEYibZ1g4/4OMwpxYiFp2W9lY=",
//     "signPdf": "9C37C119F116952B45544CA6EB32D226F08C88DFF1E70C9E21E1826DE61BF7A9",
//     "signatureBase64": "aU3yr2tnA4fPc6DFrh8eaGXBv0rRHoqyGqVpDBppWlaFVTW164rTTArASalIhwlsU4Tfa4+uOCYuazdLPvoJLVuPWcJpnxgprhg0A9CpfGnvw8jviIWJe/MwiWMmA6knl/aPRb6fFf0zupu0x+NUjn7JfitL3cMXXxg7uEdYbYPFNgX20wtKQglcM95zwqLUWuEP8FSiVnByY9BYO8HsCNq6OdSZqJBJSjrZgjexE3naW6krTtlZZXOJXix9yr/7vrXeNp3nJDZGOToK3y9p0DuZG0OIBXUP32/ZFt60EnQ7936gIliyoxEgTgGbcY0rWLJFxeem6YaZ8lgTekozPw=="
//   }
// ]

function signHashNormal(comp, strContracts, sessionId, serialNumber) {
  return new Promise((resolve, reject) => {
    //validate
    // strContracts = `[
    //   {
    //     "path": "22D0551A6ADE3475A37F485E5DCF36734CA241A4F45F35C09ABDB40A695D565A",
    //     "hash": "B/tohtbZMB6K5lLVqGrwWT4wnOBJoAGAw+0ZL3S9Yys=",
    //     "signPdf": "B4C56DCBFB7B384DDE2EF59EA06AB9B327ED54C44AF6AD573CF0C2879F4DF061",
    //     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA=="
    //   },
    //   {
    //     "path": "9EED391DA696EEBCD1D80713ECA32937E3D4DF0AE637AE290733FEBD365AB87F",
    //     "hash": "zps7wM9HdMdZ6XDNd+8nbbpr1PkGMNunweEUqlY9Os0=",
    //     "signPdf": "2F31AEF62DB92FB922437E29E987FA44005FB94614C81F416144FDEF9C0FF916",
    //     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA=="
    //   },
    //   {
    //     "path": "B4A53F10316C3E7801F93DE40E6665A655D7DA4AF11093001EA84BC3AE880844",
    //     "hash": "9UGbDMH4H6lq0AQi6SSEYibZ1g4/4OMwpxYiFp2W9lY=",
    //     "signPdf": "9C37C119F116952B45544CA6EB32D226F08C88DFF1E70C9E21E1826DE61BF7A9",
    //     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA=="
    //   }
    // ]`
    let response = "";
    let xmlhttp;
    if (window.XMLHttpRequest) {
      // code for IE7+, Firefox, Chrome, Opera, Safari
      xmlhttp = new XMLHttpRequest();
    } else {
      // code for IE6, IE5
      xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange = async function () {
      if (xmlhttp.readyState === 4 && xmlhttp.status === 0) {
        comp.showErrMsgTransle("messages.not_initPlugin");
        reject();
      }
      if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
        response = xmlhttp.responseText;
        if (response) {
          var responseAsJSON = JSON.parse(response);
          // console.log(responseAsJSON)

          var { error, signatureBase64, contracts } = responseAsJSON;
          if (contracts && contracts.length > 0) {
            const resLotUsb = contracts[0].contractAttachments;
            console.log("res sign lot usb: ", resLotUsb);
            resolve(resLotUsb);
          }

          console.log(
            "error, sign, contracts ",
            error,
            signatureBase64,
            contracts
          );

          if (signatureBase64) {
            var signature = signatureBase64;
            resolve(signature);
          }

          if (error) {
            if (comp.showErrMsgTransle) {
              console.log("vao error", error);
              comp.showErrMsgTransle(getErrorMessage(error.errorCode));
            }

            reject();
          }
        } else {
          comp.showErrMsgTransle("messages.error_not_certificate");
          reject();
        }
        // comp.blockUI.stop();
      }
    };
    var method = "POST";
    // var url = "http://127.0.0.1:19650/signHash";
    var url = domain + "signHash";
    xmlhttp.open(method, url, true);
    var paramNameArray = ["sessionId", "serialNumber", "hashAlg"];
    var paramValueArray = [sessionId, serialNumber, "SHA256"];
    if (strContracts) {
      console.log("before strContracts (cert.js) ", strContracts);
      try {
        const tmp = JSON.parse(strContracts);
        paramNameArray.push("stringContracts");
        const contractsForSignHash = [
          {
            contractAttachments: tmp,
          },
        ];
        paramValueArray.push(
          JSON.stringify({ contracts: contractsForSignHash })
        );
      } catch (err) {
        paramNameArray.push("hashBase64");
        paramValueArray.push(strContracts);
      }
    }
    xmlhttp.setRequestHeader(
      "Content-type",
      "application/x-www-form-urlencoded"
    );
    if (
      !paramNameArray ||
      !Array.isArray(paramNameArray) ||
      paramNameArray.length === 0 ||
      !paramValueArray ||
      !Array.isArray(paramValueArray) ||
      paramValueArray.length === 0 ||
      paramNameArray.length !== paramValueArray.length
    ) {
      try {
        xmlhttp.send();
      } catch (err) {
        comp.showErrMsgTransle("messages.error_not_certificate");
      }
    } else {
      let data = "";
      for (let i = 0; i < paramNameArray.length; i++) {
        data += paramNameArray[i] + "=" + paramValueArray[i] + "&";
      }
      if (data.length > 0) {
        data = data.substring(0, data.length - 1); //Loai bo ky tu & cuoi cung
      }
      try {
        // comp.blockUI.reset();
        // comp.blockUI.start(' ');
        console.log("stringfy signHash: ", data);
        xmlhttp.send(data);
      } catch (err) {
        comp.blockUI.stop();
        comp.showErrMsgTransle("messages.error_not_certificate");
        reject();
      }
    }
    // return signature;
    // return response;
  });
}

function ApproveHashNormal(comp, strContracts, sessionId, serialNumber) {
  return new Promise((resolve, reject) => {
    //validate
    // strContracts = `[
    //   {
    //     "path": "22D0551A6ADE3475A37F485E5DCF36734CA241A4F45F35C09ABDB40A695D565A",
    //     "hash": "B/tohtbZMB6K5lLVqGrwWT4wnOBJoAGAw+0ZL3S9Yys=",
    //     "signPdf": "B4C56DCBFB7B384DDE2EF59EA06AB9B327ED54C44AF6AD573CF0C2879F4DF061",
    //     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA=="
    //   },
    //   {
    //     "path": "9EED391DA696EEBCD1D80713ECA32937E3D4DF0AE637AE290733FEBD365AB87F",
    //     "hash": "zps7wM9HdMdZ6XDNd+8nbbpr1PkGMNunweEUqlY9Os0=",
    //     "signPdf": "2F31AEF62DB92FB922437E29E987FA44005FB94614C81F416144FDEF9C0FF916",
    //     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA=="
    //   },
    //   {
    //     "path": "B4A53F10316C3E7801F93DE40E6665A655D7DA4AF11093001EA84BC3AE880844",
    //     "hash": "9UGbDMH4H6lq0AQi6SSEYibZ1g4/4OMwpxYiFp2W9lY=",
    //     "signPdf": "9C37C119F116952B45544CA6EB32D226F08C88DFF1E70C9E21E1826DE61BF7A9",
    //     "fileId": "NTA0ZHMkZCNzQSYqJioyODMwNA=="
    //   }
    // ]`
    let response = "";
    let xmlhttp;
    if (window.XMLHttpRequest) {
      // code for IE7+, Firefox, Chrome, Opera, Safari
      xmlhttp = new XMLHttpRequest();
    } else {
      // code for IE6, IE5
      xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange = async function () {
      if (xmlhttp.readyState === 4 && xmlhttp.status === 0) {
        comp.showErrMsgTransle("messages.not_initPlugin");
        reject();
      }
      if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
        response = xmlhttp.responseText;
        if (response) {
          var responseAsJSON = JSON.parse(response);
          // console.log(responseAsJSON)

          var { error, signatureBase64, contracts } = responseAsJSON;
          if (contracts && contracts.length > 0) {
            const resLotUsb = contracts[0].contractAttachments;
            console.log("res sign lot usb: ", resLotUsb);
            resolve(resLotUsb);
          }

          console.log(
            "error, sign, contracts ",
            error,
            signatureBase64,
            contracts
          );

          if (signatureBase64) {
            var signature = signatureBase64;
            resolve(signature);
          }

          if (error) {
            if (comp.showErrMsgTransle) {
              console.log("vao error", error);
              comp.showErrMsgTransle(getErrorMessageApprove(error.errorCode));
            }

            reject();
          }
        } else {
          comp.showErrMsgTransle("messages.error_not_certificate");
          reject();
        }
        // comp.blockUI.stop();
      }
    };
    var method = "POST";
    // var url = "http://127.0.0.1:19650/signHash";
    var url = domain + "signHash";
    xmlhttp.open(method, url, true);
    var paramNameArray = ["sessionId", "serialNumber", "hashAlg"];
    var paramValueArray = [sessionId, serialNumber, "SHA256"];
    if (strContracts) {
      console.log("before strContracts (cert.js) ", strContracts);
      try {
        const tmp = JSON.parse(strContracts);
        paramNameArray.push("stringContracts");
        const contractsForSignHash = [
          {
            contractAttachments: tmp,
          },
        ];
        paramValueArray.push(
          JSON.stringify({ contracts: contractsForSignHash })
        );
      } catch (err) {
        paramNameArray.push("hashBase64");
        paramValueArray.push(strContracts);
      }
    }
    xmlhttp.setRequestHeader(
      "Content-type",
      "application/x-www-form-urlencoded"
    );
    if (
      !paramNameArray ||
      !Array.isArray(paramNameArray) ||
      paramNameArray.length === 0 ||
      !paramValueArray ||
      !Array.isArray(paramValueArray) ||
      paramValueArray.length === 0 ||
      paramNameArray.length !== paramValueArray.length
    ) {
      try {
        xmlhttp.send();
      } catch (err) {
        comp.showErrMsgTransle("messages.error_not_certificate");
      }
    } else {
      let data = "";
      for (let i = 0; i < paramNameArray.length; i++) {
        data += paramNameArray[i] + "=" + paramValueArray[i] + "&";
      }
      if (data.length > 0) {
        data = data.substring(0, data.length - 1); //Loai bo ky tu & cuoi cung
      }
      try {
        // comp.blockUI.reset();
        // comp.blockUI.start(' ');
        console.log("stringfy signHash: ", data);
        xmlhttp.send(data);
      } catch (err) {
        comp.blockUI.stop();
        comp.showErrMsgTransle("messages.error_not_certificate");
        reject();
      }
    }
    // return signature;
    // return response;
  });
}

function subStringTaxCode(ReqDN) {
  let key = ReqDN.search("MST");

  if (key === -1) {
    key = ReqDN.search("CMND");
  }

  if (key === -1) {
    key = ReqDN.search("CCCD");
  }

  return ReqDN.substring(key, ReqDN.length);
}

function getErrorMessage(error_code = null) {
  let error_msg;
  switch (error_code) {
    case 300:
      error_msg = "messages.choose_certificate";
      break;
    case 401:
      error_msg = "messages.sign_fail_user_cancellation";
      break;
    default:
      error_msg = "messages.not_connect_plugin";
  }
  return error_msg;
}

function getErrorMessageApprove(error_code = null) {
  let error_msg;
  switch (error_code) {
    case 300:
      error_msg = "messages.choose_certificate";
      break;
    case 401:
      error_msg = "messages.approve_fail_user_cancellation";
      break;
    default:
      error_msg = "messages.not_connect_plugin";
  }
  return error_msg;
}
